module.exports = "/_next/static/images/9b5ab30a493e920c160e109355a36951-frozen.svg.webp";